import { defineRecipe } from "@chakra-ui/react";

export const CloseButtonRecipe = defineRecipe({
  base: {
    padding: "sm",
  },
});

export default CloseButtonRecipe;
